var map = {
	".": 6,
	"./": 6,
	"./App": 9,
	"./App.css": 35,
	"./App.js": 9,
	"./App.test": 38,
	"./App.test.js": 38,
	"./AppLib.css": 36,
	"./AppRespond.css": 37,
	"./Navigation": 16,
	"./Navigation.js": 16,
	"./common/Section": 7,
	"./common/Section.css": 39,
	"./common/Section.js": 7,
	"./common/Section.test.": 40,
	"./common/Section.test..js": 40,
	"./common/Services": 8,
	"./common/Services.css": 41,
	"./common/Services.js": 8,
	"./common/Services.test": 42,
	"./common/Services.test.js": 42,
	"./heizung/Heizung": 17,
	"./heizung/Heizung.js": 17,
	"./heizung/Heizung.test": 44,
	"./heizung/Heizung.test.js": 44,
	"./heizung/VaillantLightBox.css": 43,
	"./home/Home": 18,
	"./home/Home.js": 18,
	"./home/Home.test": 45,
	"./home/Home.test.js": 45,
	"./ihr-bad/IhrBad": 19,
	"./ihr-bad/IhrBad.js": 19,
	"./ihr-bad/IhrBad.test": 46,
	"./ihr-bad/IhrBad.test.js": 46,
	"./impressum/Impressum": 20,
	"./impressum/Impressum.js": 20,
	"./impressum/Impressum.test": 47,
	"./impressum/Impressum.test.js": 47,
	"./index": 6,
	"./index.css": 29,
	"./index.js": 6,
	"./kontakt/Kontakt": 21,
	"./kontakt/Kontakt.js": 21,
	"./kontakt/Kontakt.test": 48,
	"./kontakt/Kontakt.test.js": 48,
	"./logo.svg": 108,
	"./photovoltaik/Photovoltaik": 22,
	"./photovoltaik/Photovoltaik Rework": 49,
	"./photovoltaik/Photovoltaik Rework.js": 49,
	"./photovoltaik/Photovoltaik.js": 22,
	"./photovoltaik/Photovoltaik.test": 50,
	"./photovoltaik/Photovoltaik.test.js": 50,
	"./sanitaer/Sanitaer": 23,
	"./sanitaer/Sanitaer.js": 23,
	"./sanitaer/Sanitaer.test": 51,
	"./sanitaer/Sanitaer.test.js": 51,
	"./ueber-uns/UeberUns": 24,
	"./ueber-uns/UeberUns.css": 109,
	"./ueber-uns/UeberUns.js": 24,
	"./ueber-uns/UeberUns.test": 52,
	"./ueber-uns/UeberUns.test.js": 52
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94;


//////////////////
// WEBPACK FOOTER
// ./src ^.*$
// module id = 94
// module chunks = 0